import axios2 from "axios";
import { BKVPlanType } from "src/components/types/plans";
import constants from "src/constants";
import axios from "src/lib/axios";
import { AddressType } from "src/slices/bkvReducer";

export const addressValidator = async (term) => {
  const response = await axios.post(`/powerlego/address_validator`, {
    term: term,
  });
  return response;
};

export const getAccessToken = async () => {
  const response = await axios.get(`/customer/create`);
  return response;
};

export const updateCustomer = async (payload) => {
  const response = await axios.patch(`/customer/update`, payload);
  return response;
};

export const fetchForecastUsage = async (address: AddressType) => {
  const response = await axios.post(`/powerlego/usage_estimator`, {
    address1: address.street,
    city: address.city,
    state: address.state,
    zipcode: address.zipcode,
  });
  return response;
};
export const fetchPremiseDetails = async (address) => {
  const response = await axios.post(`/powerlego/premise`, {
    address: address.street,
    zipcode: address.zipcode,
  });
  return response;
};

export const getScreenContent = async (type) => {
  const response = await axios.post(`/customer/get_contents`, {
    type: type,
  });
  return response;
};
export const BKVE_UTIL_CODES: {
  [key: string]: string
} = {
  "CPE": "CNP",
  "Oncor": "ONC",
  "AEPWTU": "AEPN",
  "TNMP": "TNMP",
  "AEPCPL": "AEPC",
  "LPL": "LPL"
}
export const fetchBluebonnet = async (zipcode, utilityCode, promocode?) => {
  const _utilityCode = BKVE_UTIL_CODES[utilityCode];
  let payload = {
    Zip: zipcode,
    UtilityCode: _utilityCode,
    PromoCode: "",
    CustomerTypeID: constants.CustomerTypeID,
  };
  if (promocode) {
    // payload["PromoCode"] = promocode;
    payload["PromoCode"] = "SEOEIQ0001";
  }
  const response = await axios.post(`/bkv/GetPlans2`, payload);
  return response;
};

export const getProviders = async () => {
  const response = await axios.post(`/powerlego/smt/retail_electric_providers`);
  return response;
};

export const getCompetitors = async (
  type,
  utility_id,
  bluebonnet: BKVPlanType
) => {
  const response = await axios.post(`/powerlego/planAndMarketScan`, {
    bluebonnet: {
      energycharge: bluebonnet["Pricing"][0]?.["EnergyCharge"],
    },
    type,
    utility_id,
  });
  return response;
};

export const getNewAgreement = async (
  esiid,
  meter_number,
  certificate_number,
  email,
  email_forward
) => {
  const response = await axios.post(`/powerlego/smt/new_agreement`, {
    esiid,
    meter_number,
    certificate_number,
    email,
    email_forward,
  });
  return response;
};

export const getAgreement = async (consent_id) => {
  const response = await axios.post(`/powerlego/smt/get_agreement`, {
    consent_id,
  });
  return response;
};

export const fetchAgreement = async (consentId: string) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer d45028a4c5774ccbbbc01ad59162cd53`);

  const formdata = new FormData();
  formdata.append("consent_id", consentId);
  formdata.append("vip", "1");

  const url = `https://www.powerlego.com/ApiGateway/v2/smt/get_agreement`;
  // const url = 'https://eiq-api.bkvenergy.com/powerlego/smt/get_agreement'

  const response = await fetch(url, {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  });
  return response.json();
};

export const fetchSmtUsage = async (esiid, consentId, startDate, endDate) => {
  try {
    const response = await axios.post(`/powerlego/monthly`, {
      esiid,
      consent_id: consentId,
      start_date: startDate,
      end_date: endDate,
    });
    return response.data;
  } catch (e) {
    console.log(e);
  }
  return null;
};

export const fetchUtilityCode = async (zipcode) => {
  const response = await axios.post("/powerlego/get_utility", {
    zipcode: zipcode,
  });
  return response;
};

export const fetchTduUsage = async (utility_code, address, email) => {
  const response1 = await axios.post("/powerlego/tdu_usage_retriever/submit", {
    esiid: address.esiid,
    zipcode: address.zipcode,
    utility_code,
    email,
  });
  let res;
  for (let i = 0; i < constants.apiCallLimit; i++) {
    let _res = await getUsageArray(response1.data.response.consent_id, 1);
    if (_res.data.status === "1") {
      res = _res.data.data;
      i = constants.apiCallLimit + 1;
    }
  }
  return res;
};

export const getUsageArray = async (consent_id, attempt) => {
  if (attempt > constants.apiCallLimit) {
    throw new Error("Usage not found");
  }
  return await axios.post("/powerlego/tdu_usage_retriever/get", {
    consent_id: consent_id,
  });
};

export const postFooterForm = async (email) => {
  const formData = new FormData();
  formData.append("_wpcf7", String(constants._wpcf7));
  formData.append("_wpcf7_version", "");
  formData.append("_wpcf7_unit_tag", constants._wpcf7_unit_tag);
  formData.append("_wpcf7_container_post", String(constants._wpcf7));
  formData.append("_wpcf7_posted_data_hash", "");
  formData.append("_wpcf7_locale", constants._wpcf7_locale);
  formData.append("your-email", email);
  formData.append("_wpcf7_ak_hp_textarea", "");
  formData.append("_wpcf7_ak_js", String(constants._wpcf7_ak_js));

  const myHeaders = new Headers();
  myHeaders.append("content-type", "multipart/form-data");

  let url = constants.FEEDBACK_URL;

  const response = await axios2.post(url, formData, {
    headers: myHeaders,
  });
  return response;
};
